import React, { useState, useEffect,useContext } from "react";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { Avatar, Link } from "@material-ui/core";
import { Spacing, FontSize, Colors } from "../../theme/Theme";
import { StarRatings } from "../../components/StarRatings";
import {
  getMonthAndYearComparedToNow,
  formatWorkerType,
  getMonthAndYearByMonth,
} from "../../util/FormattingService";
import { RBButton, RBButtonType } from "../../components/RBButton";
import { NotAvailableString,ApprovalModeEnum, roleNameEnum, RoutePathConstant } from "../../util/Common";
import { isWorkerRBPayVerified, isRBPayAvailableForLocation } from "../../util/rbPay";
import { RBPayrollVerifiedBadge } from "../searchShift/RBPayrollVerifiedBadge";
import { rbPayrollOwnerService } from "../rbPayrollOwnerSettings/services/rbPayrollOwner.service";
import { RBPayrollStatus } from "../rbPayrollOwnerSettings/types/rbPayrollOwner.types";
import { ColumnStyle } from "../../theme/ComponentTheme";
import {
  RenderTextWithTitle,
  renderTextWithTitleForSkills,
  renderTextWithTitleAndChildComponent,
  detailTextStyle,
} from "../../components/TextWithHeader";
import { RBCardView } from "../../components/RBCardView";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { workerTypeEnum } from "../../util/Enumeration";
import { ShiftService } from "../../api/ShiftService";
import { ApplicantState } from "../../interfacesProps/SetApplicantStateByPharmacyProps";
import axios from 'axios';
import { Document, Page } from 'react-pdf';
import {
  useHistory,
  RouteComponentProps,
  withRouter,
  useLocation,
} from "react-router";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { ShiftProps } from "../../interfacesProps/ShiftProps";
import { RBContext } from "../../components/RBContext";
import moment from 'moment';
import { IndustryModeEnum } from "../../api/constants";
import { AuthService } from "../../api/AuthService";
import RBPlacementFeeModal from "../../components/RBPlacementFeeModal";
import { RBModal,RBProofModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import PDFViewer from "../../components/PdfViewer";
import { WorkerStats } from "../../components/WorkerStats";
import { FormControlLabel, Checkbox, Typography } from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { showOnHoldAlert } from "../../util/showOnHoldAlert";
import { UploadDocumentCredentialsService } from "../../api/UploadDocumentCredentials";
import { ApplicantRequest } from "../../components/ApplicantRequest";
import OriginalShiftDetails from "../../components/OriginalShiftDetail";
import { defaultAllowOffersIcon } from "../../components/RBShiftRelatedIcons";

interface ViewApplicantsPageWithoutRouterProps
  extends RouteComponentProps<{ shiftId: string; userId?: string  }> {}


  interface PdfDataUrls {
    [key: string]: string;
  }

const ViewApplicantsPageWithoutRouter: React.FC<ViewApplicantsPageWithoutRouterProps> = ({
  match,
}) => {
  const [shiftId] = useState(match.params.shiftId);
  const userId = match.params.userId;
  const isSingleView = !!userId;

  const [shiftData, setShiftData] = useState<ShiftProps>({});
  const [reloadPage, setReloadPage] = useState(false);
  const [applicants, setApplicants] = useState<ObjectLiteral[]>([]);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [extendeds, setExtendeds] = useState<Set<string>>(new Set());
  const [isAlertShowing, setAlertShowing] = useState(false);
  const [alertInfo, setAlertInfo] = useState<AlertInfoProps>({});
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | undefined>();
  const { industryMode,primaryColor,secondaryColor,contactEmail } = useContext(RBContext);
  const [account, setAccount] = useState<any>([]);
  const [resumeModal, setReumeModal] = useState(false);
  const [pdfDataStatus, setPdfDataStatus] = useState<{ [key: number]: boolean }>({});
  const [selectedApplicant, setSelectedApplicant] = useState<any>(null); // Store the selected applicant
  const [numPages, setNumPages] = useState<any>(null);
  const [currentPharmacy, setCurrentPharmacy] = useState<any>(null);
  const [roleName, _] = useState<string>(AuthService.getRoleName());
  // True only when this owner's location has NOT started RB Pay setup — drives the
  // "Setup RB Pay" CTA under the verified badge. Fetched once at screen level.
  const [locationRBPayNotSetup, setLocationRBPayNotSetup] = useState(false);

  const history = useHistory();

  const [proofsModalOpen, setProofsModalOpen] = useState(false);
  const [proofList, setProofList] = useState<any[]>([]);
  const [proofViewerOpen, setProofViewerOpen] = useState(false);
  const [selectedProof, setSelectedProof] = useState<any>(null);

  const TopAppBarHeight = 60;

  useEffect(() => {
    const fetchData = async () => {
      try {

        localStorage.removeItem("downloadedPdf")
        setIsPageLoading(true);

        const userData = await AuthService.loadAccountInfo();

        const applicantsData = await ShiftService.getShiftApplicantsByShiftId(
          match.params.shiftId
        );
        const shiftDetailData = await ShiftService.getShiftDetailByShiftId(
          match.params.shiftId
        );
        setAccount(userData);
        setShiftData(shiftDetailData);

        // Owner-only: determine whether THIS location still needs RB Pay setup so we
        // can offer the contextual "Setup RB Pay" CTA. A 404 (no profile) maps to
        // NOT_STARTED inside the service. Non-owners can't manage RB Pay → CTA stays
        // hidden, so we skip the lookup entirely. Also gate on the location's admin
        // availability flag (pharmacy.isRbPayAvailable): when RB Pay isn't enabled
        // for this location there is no setup to offer. Resolve the flag from
        // account.pharmacies (the full DTO reliably carries it) since the shift
        // detail's pharmacy projection may omit it; fall back to it if no match.
        const availabilitySource =
          userData?.pharmacies?.find((p: any) => String(p?.id) === String(shiftDetailData?.pharmacy?.id)) ||
          shiftDetailData?.pharmacy;
        if (userData?.owner && shiftDetailData?.pharmacy?.id && isRBPayAvailableForLocation(availabilitySource)) {
          try {
            const status = await rbPayrollOwnerService.getRBPayrollStatus({
              account: userData,
              location: shiftDetailData.pharmacy,
            });
            setLocationRBPayNotSetup(status === RBPayrollStatus.NOT_STARTED);
          } catch (statusErr) {
            console.log("RB Pay location status error", statusErr);
          }
        }
        // if a userId is present, show only that applicant (replicates ViewRequestApplicantPage behavior)
        if (match.params.userId) {
          const filteredApplicant = applicantsData.data.find(
            (applicant: any) => applicant?.id === match.params.userId
          );
          setApplicants(filteredApplicant ? [filteredApplicant] : []);
        } else {
          setApplicants(applicantsData.data);
        }
        
      } catch (err) {
        const responseData = (err as any)?.response?.data;
        setSubmitErrorMessage(
          responseData?.message || responseData?.error || (err as any)?.message || 'Unable to load applicants. Please try again.'
        );
        console.log("ViewApplicantsPageWithoutRouter error", err);
      } finally {
        setIsPageLoading(false);
      }
    };

    fetchData();
  }, [reloadPage]);

  // useEffect(() => {
  //   applicants.forEach(applicant => {
  //     if (!pdfDataStatus[applicant.id]) {
  //       fetchAndStorePdfData(applicant);
  //     }
  //   });
  // }, [applicants, pdfDataStatus]);


  const fetchAndStorePdfData = async (applicant:any) => {
    console.log(" ",applicant)
    const resumeUrl = applicant?.resume;
    
    axios.get(resumeUrl, { responseType: 'arraybuffer' })
      .then(response => {
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        const pdfData = URL.createObjectURL(pdfBlob);
        
        setSelectedApplicant((prevApplicants:any) => {
              return {
                ...prevApplicants,
                pdfDataUrl: pdfData,
              }
        });
      })
      .catch(() => {
        console.log('Error fetching PDF data.');
      });
  };

  // useEffect(() => {
  //   // Loop through your applicants and fetch PDF data
  //   applicants.forEach(applicant => {
  //     fetchAndStorePdfData(applicant);
  //   });
  // }, [applicants]);
 const setAlertState = (newState:any) => {
    setAlertShowing(newState.isAlertShowing);
    setAlertInfo(newState.alertInfo);
  };


   // fetch proofs and open list modal (shows N/A alert if none)
  const openProofsForApplicant = (applicant: any) => {
    try {
      const docs = (applicant.documents || []).map((d: any) => ({
        id: d.id,
        name: d.documentName || "Document",
        fileUrl: d.documentFile,
        updatedAt: d.updatedAt,
      }));

      if (!docs.length) {
        setAlertInfo({
          title: "Proof of Credentials",
          message: "N/A — no proof of credentials available for this worker.",
          buttons: [
            <RBButton key="ok" onClick={() => setAlertShowing(false)} text="OK" buttonBackgroundColor={primaryColor} />
          ],
        });
        setAlertShowing(true);
        return;
      }

      setProofList(docs);
      setProofsModalOpen(true);
    } catch (err) {
      setSubmitErrorMessage((err as any)?.response ? (err as any).response.data : (err as any).message);
    }
  }

  const openProofViewer = async (proof:any) => {
    try {
      const url = proof?.fileUrl;
      if (!url) return;

      // detect pdf by path (handles querystring)
      const isPdf = /\.pdf(\?|$)/i.test(url);

      if (isPdf) {
        // fetch PDF as arraybuffer and create blob URL to avoid react-pdf CORS issues
        const resp = await axios.get(url, { responseType: "arraybuffer" });
        const pdfBlob = new Blob([resp.data], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(pdfBlob);
        setSelectedProof({ ...proof, fileUrl: blobUrl, isPdf: true, _objectUrl: blobUrl });
      } else {
        // image or other file - use original url
        setSelectedProof({ ...proof, fileUrl: url, isPdf: false });
      }
      setNumPages(null);
      setProofViewerOpen(true);
    } catch (err) {
      console.error("openProofViewer error", err);
      setSubmitErrorMessage((err as any)?.response ? (err as any).response.data : (err as any).message);
    }
  };
   const closeProofViewer = () => {
    // revoke object URL if we created one
    if (selectedProof && (selectedProof as any)._objectUrl) {
      try {
        URL.revokeObjectURL((selectedProof as any)._objectUrl);
      } catch (e) { /* ignore */ }
    }
    setProofViewerOpen(false);
    setSelectedProof(null);
    setNumPages(null);
  };
  const closeProofsModal = () => { setProofsModalOpen(false); setProofList([]); };

   // lightweight renderer to reuse the same structure as renderResume
  const renderProofs = (applicant: any) => {
    const hasProof = (applicant?.documents || []).length > 0;
    return (
      <>
        {hasProof
          ? renderTextWithTitleAndChildComponent(
              "Proof(s) of Credentials",
              <Link
                onClick={() => openProofsForApplicant(applicant)}
                style={{ ...detailTextStyle, color: Colors.themeBlue, cursor: 'pointer' }}
              >
                {"View"}
              </Link>
            )
          : RenderTextWithTitle("Proof(s) of Credentials", NotAvailableString)}
      </>
    );
  };


  const setExtendedsForPharmacist = (pharmacistId: string) => {
    if (
      shiftData?.pharmacy?.approval?.approvalMode  === ApprovalModeEnum.OnHold
    ) {
      showOnHoldAlert({
        setAlertState,
        primaryColor,
        contactEmail,
      });
      return;
    }
    //const { extendeds } = this.state;
    if (extendeds.has(pharmacistId)) {
      extendeds.delete(pharmacistId);
      //Since react will identify state changes only if the state property was replaced, and not mutated (shallow compare), you'll have to create a new Set from the old one, and apply the changes to it.

      setExtendeds(new Set(extendeds));
    } else {
      extendeds.add(pharmacistId);
      setExtendeds(new Set(extendeds));
    }
  };

  const renderSkills = (worker: ObjectLiteral) => {
    const skills = worker.skills || [];
    const skillSets = account?.networks?.[0]?.skillSet?.workerSkillSets || [];

    return (
      <>
        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        {skillSets.length > 0 &&
          skillSets.map((skillType: any) => {
            const matchedSkills = skills
              .filter((skill: any) => skill.type === skillType)
              .map((skill: any) => skill.name);

            const capitalizedTitle =
              skillType.charAt(0).toUpperCase() +
              skillType.slice(1) +
              (skillType === 'specialization' ? 's' : '');

            return (
              <div style={ColumnStyle}>
                {renderTextWithTitleForSkills(capitalizedTitle, matchedSkills)}
              </div>
            );
          })}
      </>
    );
  };
  const  renderRequestedWage = (requestedWage:any) => {

    const allowOffers = shiftData.allowOffers;

    if (allowOffers) {
      if (shiftData.pharmacy?.networkPaid) {
        //if (this.state.workerFee == null) {
          shiftData.requestedWage = requestedWage;
          const workerFee = requestedWage/100 ;
         // this.setState({ workerFee: workerFee });
        //}

        return (
          RenderTextWithTitle(
            'Requested Rate',
            '$' + workerFee.toFixed(2),
          )
        )
      }
      else {
        return (
          RenderTextWithTitle(
            'Requested Rate',
            '$' + (requestedWage / 100).toFixed(2),
          )
        )
      }
    } else{
      return null
    }
  };
  const renderRbCommission = (requestedWage:any) => {
    
    const allowOffers = shiftData.allowOffers;

    //const { rbCommission } = this.state;

    if (allowOffers) {
      if (shiftData.pharmacy?.networkPaid) {

          shiftData.requestedWage = requestedWage;
          const rbCommission = shiftData.actualCommission !== undefined && shiftData.actualCommission !== null ? ShiftService.getPlacementFee(shiftData).toFixed(2) :(
            ShiftService.getCommission(shiftData,account) / 100
          ).toFixed(2);
        

        return (
          <RBPlacementFeeModal title={'Placement Fee'}
           detail={'$' + rbCommission} 
            commissionType={shiftData.commissionType ?? shiftData.pharmacy.commissionType}/>
         
        )
      }
    } else {
      return (null)
    }
  };
  const renderName = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const name = `${pharmacist.firstName} ${pharmacist.lastName}`;
    const rating = applicant.rating.averageRating ?? 0;
    const numberRatings = applicant.rating.numberRatings ?? 0;
    const requestedWage = applicant.userToRequests[0].requestedWage;
    const workerType = formatWorkerType(pharmacist.type);
    return (
      <>
      <div
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            flex: 1,
          }}
        >
          <div
            style={{
              fontSize: FontSize.largest,

              fontWeight: "bold",
              flexWrap: "wrap",
            }}
          >
            {name}
          </div>

          <StarRatings rating={rating} numberReviews={numberRatings} page="shiftDetails"/>
        </div>
      </div>
      <div style={ColumnStyle}>
          
         
          {/* {shiftData?.pharmacy?.networkPaid && shiftData.allowOffers ? */}
            {shiftData?.pharmacy?.networkPaid ? 
            <>
            {RenderTextWithTitle("", "")}
             {RenderTextWithTitle("", "")}
              {RenderTextWithTitle("", "")}
            {/* {renderRequestedWage(requestedWage)} */}
            {/* {renderRbCommission(requestedWage)} */}
            </>:
            <>
            {RenderTextWithTitle("", "")}
            {RenderTextWithTitle("", "")}
            {RenderTextWithTitle("", "")}
            {/* {renderRequestedWage(requestedWage)} */}

            </>
          }
     </div>
     
     </>
    );
  };

  const getAllowanceCostWithTax = (worker: any) => {
    const taxRate = (shiftData.salesTaxRate ?? 0) / 100;
    const allowanceCost =
      ((Math.round((worker.distance * 2) / 1000) * shiftData.kmAllowance) /
        100 +
        shiftData.accomodationAllowance / 100) *
      (1 + taxRate);
    return allowanceCost;
  };
  const renderStudent = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const allowanceCost = getAllowanceCostWithTax(applicant);
    const showExtended = extendeds.has(applicant.id);

    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Type", formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle("Registration #", pharmacist.licenseNumber)}
          {RenderTextWithTitle(
            "Assist Experience",
            getMonthAndYearByMonth(pharmacist.pharmacyAssistantExperienceMonths)
          )}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Academic Year", pharmacist.currentSchoolYear)}
          {RenderTextWithTitle("Institution", pharmacist.graduationInstitution)}
          {RenderTextWithTitle(
            "Allowance Cost",
            "$" + allowanceCost.toFixed(2)
          )}
        </div>
        <div style={ColumnStyle}>
          {renderResume(pharmacist)}
           {renderProofs(applicant)}
           {RenderTextWithTitle("", "")}
          
          </div>
        {isSingleView && (
          <OriginalShiftDetails
            applicant={applicant}
            shiftId={shiftId}
            shiftData={shiftData}
            account={account}
          />
        )}
        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <ApplicantRequest applicant={applicant} shiftId={shiftId} shiftData={shiftData} page="viewApplicant" />
                 <div
                  style={{
                    height: 1,
                    backgroundColor: 'lightgray',
                    marginTop:10,
                    marginBottom:10
                  }}
                />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about &&(
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
            {applicant.pharmacist.about || 'N/A'}
            </div>
          </>
        )}
 

        {/* {showExtended && applicant.networks[0].isAcceptedEmploymentTypesEnabled=== true && applicant.pharmacist.acceptedEmploymentTypes &&
          <>
          <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
          <div style={{ marginTop: Spacing.medium }}>
          <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
          <div style={{ display: 'flex', flexDirection: 'column'}}>
            {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
              <FormControlLabel
                key={method}
                control={
                  <Checkbox
                    checked={true}
                    icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                  />
                }
                label={method}
              />
            ))}
          </div>
        </div>
        </>
        } */}
        <>{showExtended && renderSkills(pharmacist)}</>

      </>
    );
  };
  const renderAssistant = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    console.log("renderAssistant ", applicant);
    const allowanceCost = getAllowanceCostWithTax(applicant);
    const yearGraduated = pharmacist.graduationYear;
    const showExtended = extendeds.has(applicant.id);

    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Type", formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle(
            "Assist Course",
            pharmacist.pharmacyAssistantCourseCompleted ? "Yes" : "No"
          )}
          {RenderTextWithTitle(
            "Assist Experience",
            getMonthAndYearByMonth(pharmacist.pharmacyAssistantExperienceMonths)
          )}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Graduate In", yearGraduated)}
          {RenderTextWithTitle(
            "Graduate From",
            pharmacist.graduationInstitution
          )}
          {RenderTextWithTitle(
            "Allowance Cost",
            "$" + allowanceCost.toFixed(2)
          )}
        </div>
        <div style={ColumnStyle}>
          {renderResume(pharmacist)}
          {renderProofs(applicant)}
           {RenderTextWithTitle("", "")}

          </div>
         {isSingleView && (
          <OriginalShiftDetails
            applicant={applicant}
            shiftId={shiftId}
            shiftData={shiftData}
            account={account}
          />
        )}
        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <ApplicantRequest applicant={applicant} shiftId={shiftId} shiftData={shiftData} page="viewApplicant" />
                 <div
                  style={{
                    height: 1,
                    backgroundColor: 'lightgray',
                    marginTop:10,
                    marginBottom:10
                  }}
                />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about && (
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
            {applicant.pharmacist.about || 'N/A'}
            </div>
          </>
        )}
        
        {/* {showExtended && applicant.networks[0].isAcceptedEmploymentTypesEnabled=== true && applicant.pharmacist.acceptedEmploymentTypes &&
        <>
        <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
        <div style={{ marginTop: Spacing.medium }}>
        <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
        <div style={{ display: 'flex', flexDirection: 'column'}}>
          {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
            <FormControlLabel
              key={method}
              control={
                <Checkbox
                  checked={true}
                  icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                  checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                />
              }
              label={method}
            />
          ))}
        </div>
      </div>
      </>
        } */}
        <>{showExtended && renderSkills(pharmacist)}</>

      </>
    );
  };
  const renderPharmacistAndTechnician = (applicant: ObjectLiteral) => {
    console.log("renderPharmacistAndTechnician ", applicant);
    const { pharmacist } = applicant;
    const yearGraduated = pharmacist.graduationYear;
    const licensedDate = pharmacist.licensedDate
      ? getMonthAndYearComparedToNow(pharmacist.licensedDate)
      : NotAvailableString;
    const allowanceCost = getAllowanceCostWithTax(applicant);
    const showExtended = extendeds.has(applicant.id);

    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("", formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle("License Number", pharmacist.licenseNumber)}
          {RenderTextWithTitle("Years Licensed", licensedDate)}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Licensed In", pharmacist.licenseProvince)}

          { shiftData.kmAllowance === 0 ? RenderTextWithTitle(
            "Distance",
            Math.round(applicant.distance / 1000) + "km (Est.)"
          ) : RenderTextWithTitle(
            "Distance",
            Math.round(applicant.distance / 1000) + "km"
          )}
          {RenderTextWithTitle(
            "Allowance Cost",
            "$" + allowanceCost.toFixed(2)
          )}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Graduate In", yearGraduated)}
          {RenderTextWithTitle(
            "Graduate From",
            pharmacist.graduationInstitution
          )}
           {RenderTextWithTitle("", "")}
          {/* {renderResume(pharmacist)} */}
        </div>

         <div style={ColumnStyle}>
          {renderResume(pharmacist)}
          {renderProofs(applicant)}
          {RenderTextWithTitle("", "")}
          
        </div>


         {isSingleView && (
          <OriginalShiftDetails
            applicant={applicant}
            shiftId={shiftId}
            shiftData={shiftData}
            account={account}
          />
        )}
        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <ApplicantRequest applicant={applicant} shiftId={shiftId} shiftData={shiftData} page="viewApplicant" />
                 <div
                  style={{
                    height: 1,
                    backgroundColor: 'lightgray',
                    marginTop:10,
                    marginBottom:10
                  }}
                />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about && (
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
              {applicant.pharmacist.about}
            </div>
          </>
        )}
       

        {/* {showExtended && applicant.networks[0].isAcceptedEmploymentTypesEnabled=== true && applicant.pharmacist.acceptedEmploymentTypes &&
         <>
         <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
         <div style={{ marginTop: Spacing.medium }}>
         <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
         <div style={{ display: 'flex', flexDirection: 'column'}}>
           {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
             <FormControlLabel
               key={method}
               control={
                 <Checkbox
                   checked={true}
                   icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                   checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                 />
               }
               label={method}
             />
           ))}
         </div>
       </div>
     </>
        } */}
        <>{showExtended && renderSkills(pharmacist)}</>

      </>
    );
  };

  const renderLicensedDentistWorker = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const showExtended = extendeds.has(applicant.id);

    const licenseExpiryDate = pharmacist.licenseExpiryDate
      ? moment(pharmacist.licenseExpiryDate).format('YYYY - MM')
      : 'N/A';
    const licensedDate = pharmacist.licensedDate
      ? getMonthAndYearComparedToNow(pharmacist.licensedDate)
      : 'N/A';
    const allowanceCost = getAllowanceCostWithTax(applicant);


    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle('', formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle("Registration #", pharmacist.licenseNumber)}
          {RenderTextWithTitle("Years Licensed", licensedDate)}
          
        </div>
        <div style={ColumnStyle}>
        {RenderTextWithTitle("Registered In", pharmacist.licenseProvince)}
          {RenderTextWithTitle("Expires On", licenseExpiryDate)}

          {RenderTextWithTitle(
            "City",
            pharmacist.address.city
          )}
          
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle(
            "Allowance Cost",
            "$" + allowanceCost.toFixed(2)
          )}
          {RenderTextWithTitle("Graduated From", pharmacist.graduationInstitution,)}
          {RenderTextWithTitle(
            "Graduated In",
            pharmacist.graduationYear,
          )}
          
        </div>
         {isSingleView && (
          <OriginalShiftDetails
            applicant={applicant}
            shiftId={shiftId}
            shiftData={shiftData}
            account={account}
          />
        )}
        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <ApplicantRequest applicant={applicant} shiftId={shiftId} shiftData={shiftData} page="viewApplicant" />
                 <div
                  style={{
                    height: 1,
                    backgroundColor: 'lightgray',
                    marginTop:10,
                    marginBottom:10
                  }}
                />
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {/* {showExtended && 
          <>{renderResume(pharmacist)}
        </>
        } */}
        {showExtended && applicant.pharmacist.about && (
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
              {applicant.pharmacist.about}
            </div>
            
          </>
        )}

        {/* {showExtended && applicant.networks[0].isAcceptedEmploymentTypesEnabled=== true && applicant.pharmacist.acceptedEmploymentTypes &&
        <>
        <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
        <div style={{ marginTop: Spacing.medium }}>
            <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
                <FormControlLabel
                  key={method}
                  control={
                    <Checkbox
                      checked={true}
                      icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                      checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    />
                  }
                  label={method}
                />
              ))}
            </div>
          </div>
        </>
        } */}
        {showExtended && 
          <>
           {renderSkills(pharmacist)}
           <div style={ColumnStyle}>
          {renderResume(pharmacist)}
          {renderProofs(applicant)}
          {RenderTextWithTitle("", "")}
           </div>
         
         </>
        }
      </>
    );
  };

  const renderNonLicensedDentistWorker = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    const showExtended = extendeds.has(applicant.id);
    const allowanceCost = getAllowanceCostWithTax(applicant);


    return (
      <>
     
        <div style={ColumnStyle}>
        {RenderTextWithTitle('', formatWorkerType(pharmacist.type))}
          {RenderTextWithTitle("Graduated From", pharmacist.graduationInstitution,)}
          {RenderTextWithTitle(
            "Graduated In",
            pharmacist.graduationYear,
          )}
         
          
        </div>
        <div style={ColumnStyle}>
        {RenderTextWithTitle(
            "Experience",
            getMonthAndYearByMonth(
              pharmacist.pharmacyAssistantExperienceMonths,
            ),
          )}
          {RenderTextWithTitle(
            "Allowance Cost",
            "$" + allowanceCost.toFixed(2)
          )}
          {RenderTextWithTitle(
            "City",
            pharmacist.address.city
          )}
          
        </div>
         {isSingleView && (
          <OriginalShiftDetails
            applicant={applicant}
            shiftId={shiftId}
            shiftData={shiftData}
            account={account}
          />
        )}
        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <ApplicantRequest applicant={applicant} shiftId={shiftId} shiftData={shiftData} page="viewApplicant" />
                 <div
                  style={{
                    height: 1,
                    backgroundColor: 'lightgray',
                    marginTop:10,
                    marginBottom:10
                  }}
                />
        
        <WorkerStats account={pharmacist} page="viewApplicant" />

        {showExtended && applicant.pharmacist.about && (
          <>
            <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
            <div style={{ fontSize: FontSize.largest, fontWeight: "bold" }}>
              About Me
            </div>
            <div style={{ marginTop: Spacing.small, marginBottom: Spacing.medium }}>
              {applicant.pharmacist.about}
            </div>
           
          </>
        )}

        {/* {showExtended && applicant.networks[0].isAcceptedEmploymentTypesEnabled=== true && applicant.pharmacist.acceptedEmploymentTypes &&
        <>
        <div style={{ height: 1, backgroundColor: 'lightgray', marginTop: 10, marginBottom: 10 }} />
        <div style={{ marginTop: Spacing.medium }}>
          <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
          <div style={{ display: 'flex', flexDirection: 'column'}}>
            {(applicant.pharmacist.acceptedEmploymentTypes || []).map((method: string) => (
              <FormControlLabel
                key={method}
                control={
                  <Checkbox
                    checked={true}
                    icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                  />
                }
                label={method}
              />
            ))}
          </div>
        </div>
        </>
        } */}
        {showExtended && 
        <> {renderSkills(pharmacist)}
          <div style={ColumnStyle}>
          {renderResume(pharmacist)}
          {renderProofs(applicant)}
          {RenderTextWithTitle("", "")}
          </div>
        {/* {renderResume(pharmacist)} */}
        
        </>
        }
      </>
    );
  };

  const openResumeModal = (applicant: any) => {
    console.log("open",applicant)
    setSelectedApplicant(applicant);
    fetchAndStorePdfData(applicant); // Fetch and store PDF data when the modal is opened
    setReumeModal(true);
  };

  

  const renderResume = (worker: ObjectLiteral) => {
    console.log("renderResume ", worker.resume);
    return (
      <>
        {worker.resume
          ? renderTextWithTitleAndChildComponent(
              "Resume",
              <Link
                onClick={() => openResumeModal(worker)}
                style={{ ...detailTextStyle, color: Colors.themeBlue, cursor: 'pointer' }}
              >
                {"View"}
              </Link>
            )
          : RenderTextWithTitle("Resume", NotAvailableString)}
      </>
    );
  };
  const selectWorker = async (workerUserId: string) => {
    try {
      setIsButtonLoading(true);
      // await new Promise((resolve) => setTimeout(resolve, 3000));
      await ShiftService.setApplicantStateByPharmacy({
        shiftId: shiftId,
        pharmacistId: workerUserId,
        state: ApplicantState.approved,
      });
      history.goBack();
    } catch (err) {
      const responseData = (err as any)?.response?.data;
      // Show titled alert for server errors (e.g., unavailable worker)
      setAlertInfo({
        title: 'Unable to select applicant',
        message:
          responseData?.message || responseData?.error || (err as any)?.message || 'Unable to select applicant. Please try again.',
        buttons: [
          <RBButton
            key="ok"
            onClick={() => {
              setAlertShowing(false);
            }}
            text="Ok"
            buttonBackgroundColor={secondaryColor}
          />,
        ],
      });
      setAlertShowing(true);
      // clear the plain error message so the RBErrorAlert (title-less) doesn't also appear
      setSubmitErrorMessage(undefined);
    } finally {
      setIsButtonLoading(false);
    }
  };
  const rejectWorker = async (workerUserId: string) => {
    try {
      setIsButtonLoading(true);
      // await new Promise((resolve) => setTimeout(resolve, 3000));
      // console.log("rejectWorker ", {
      //   shiftId: this.props.shiftId,
      //   pharmacistId: workerUserId,
      //   state: ApplicantState.denied,
      // });
      await ShiftService.setApplicantStateByPharmacy({
        shiftId: shiftId,
        pharmacistId: workerUserId,
        state: ApplicantState.denied,
      });
      setReloadPage((pre) => !pre);
      history.goBack();
    } catch (err) {
      const responseData = (err as any)?.response?.data;
      setAlertInfo({
        title: 'Unable to ignore applicant',
        message:
          responseData?.message || responseData?.error || (err as any)?.message || 'Unable to ignore applicant. Please try again.',
        buttons: [
          <RBButton
            key="ok"
            onClick={() => {
              setAlertShowing(false);
            }}
            text="Ok"
            buttonBackgroundColor={secondaryColor}
          />,
        ],
      });
      setAlertShowing(true);
      setSubmitErrorMessage(undefined);
    } finally {
      setIsButtonLoading(false);
    }
  };
  const onSelection = (applicant: ObjectLiteral) => {
    if (
      shiftData?.pharmacy?.approval?.approvalMode  === ApprovalModeEnum.OnHold
    ) {
      showOnHoldAlert({
        setAlertState,
        primaryColor,
        contactEmail,
      });
      return;
    }
    const { pharmacist } = applicant;
    const name = `${pharmacist.firstName} ${pharmacist.lastName}`;
    // requested data from the applicant (if present)
       const req = applicant?.userToRequests?.[0];
       const tz = shiftData?.shiftTimeZone ?? "UTC";
       const wage = req?.requestedWage ? `$${(req.requestedWage / 100).toFixed(2)}` : "N/A";
    
      let message: string = "";
      //  if (req?.requestedStartTime && req?.requestedEndTime) {
         const startRaw = req?.requestedStartTime ?? shiftData?.officialStartTime ?? shiftData?.officialStartTime;
         const endRaw =req?.requestedEndTime ?? shiftData?.officialEndTime ?? shiftData?.officialEndTime;
         const start = (moment as any).tz(startRaw, tz).format("ddd, MMM Do YYYY h:mm a");
         const end = (moment as any).tz(endRaw, tz).format("ddd, MMM Do YYYY h:mm a");
         message = `Hire ${name} ${formatWorkerType(pharmacist.type)} for <strong>${start}</strong> – <strong>${end}</strong> at a wage of <strong>${wage}</strong>`;
      //  } else {
        //  message = `Hire ${name} at a wage of <strong>${wage}</strong>`;
      //  }
    setAlertInfo({
      title: `Confirm ${formatWorkerType(pharmacist.type)}`,
      alertWidth: 520,
      // message: `Hire ${name} for shift?`,
       message,
      buttons: [
        <RBButton
          key="Cancel"
          onClick={() => {
            setAlertShowing(false);
          }}
          buttonType={RBButtonType.cancel}
          text="Cancel"
        />,
        <RBButton
          key="Confirm"
          onClick={async () => {
            setAlertShowing(false);
            await selectWorker(applicant.id);
          }}
          text="Confirm"
          style={{background:primaryColor}}
        />,
      ],
    });
    setAlertShowing(true);
  };

  const onReject = (applicant: ObjectLiteral) => {
    if (
      shiftData?.pharmacy?.approval?.approvalMode  === ApprovalModeEnum.OnHold
    ) {
      showOnHoldAlert({
        setAlertState,
        primaryColor,
        contactEmail,
      });
      return;
    }
    const { pharmacist } = applicant;
    const name = `${pharmacist.firstName} ${pharmacist.lastName}`;
    setAlertInfo({
      title: `Reject ${formatWorkerType(pharmacist.type)}`,
      alertWidth: 520,
      message: `Candidate ${name} will no longer be eligible for this shift.`,
      buttons: [
        <RBButton
          key={"Cancel"}
          onClick={() => {
            setAlertShowing(false);
          }}
          buttonType={RBButtonType.cancel}
          text="Cancel"
        />,
        <RBButton
          key={"Confirm"}
          onClick={async () => {
            setAlertShowing(false);
            await rejectWorker(applicant.id);
          }}
          text="Confirm"
          style={{background:primaryColor}}
        />,
      ],
    });
    setAlertShowing(true);
  };
  const renderAlerts = () => {
    return (
      <RBAlert
        show={isAlertShowing}
        alertTitle={alertInfo.title}
        alertMessage={alertInfo.message}
        buttons={alertInfo.buttons}
        alertWidth={alertInfo.alertWidth}
      />
    );
  };
  const goToRBPaySetup = () => {
    history.push(RoutePathConstant.RBPayrollOwnerSetup, {
      selectedLoc: shiftData.pharmacy,
    });
  };

  const renderApplicant = (applicant: ObjectLiteral) => {
    const { pharmacist } = applicant;
    console.log("renderApplicant ", selectedApplicant);
    const showExtended = extendeds.has(applicant.id);
    let associationLogo = null;
    const userAssociationMember = applicant.userAssociationMember || [];
    const rbVerified = (applicant.pharmacist?.approval && applicant.pharmacist?.approval?.rbVerified) ? applicant.pharmacist?.approval?.rbVerified : false;
    if (userAssociationMember.length > 0) {
      associationLogo = userAssociationMember[0].association.logo;
    }
    // if(shiftData.pharmacy)
    // {
    //   if(!shiftData.pharmacy.approval){
    //     shiftData.pharmacy.approval={approvalMode:ApprovalModeEnum.OnHold}
    //   }
    // }

    return (
      <>
      {selectedApplicant && <RBModal
          open={resumeModal}
          onClose={onResumeClose}
          modalTitle={"Resume"
          }
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
          children={
              renderRequestedRateContent(selectedApplicant)
          }
        />}
      
     
      <div
        style={{
          display: "flex",
          width: "100%",
          paddingLeft: Spacing.large,
          paddingRight: Spacing.large,
          paddingTop: Spacing.large,
          paddingBottom: Spacing.large,
          flexDirection: "row",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {/* Avatar and association logo */}
          <div>
            <Avatar
              style={{ height: 124, width: 124 }}
              // src={pharmacist.profilePhoto}
              src={pharmacist.profilePhoto}
            >
              :(
            </Avatar>
            {associationLogo && (
              <>
              <img
                src={associationLogo}
                alt={"associationLogo"}
                style={{
                  width: 96,
                  height: 36,
                  marginTop: 4,
                  marginBottom: 4,
                }}
              />
              <br></br>
              </>
            )}
             {
              (rbVerified === false
                && applicant.networks[0].id === "7b89c1df-df98-41e8-a06c-f3d1d748de84"
                && shiftData.pharmacy?.networkId === "7b89c1df-df98-41e8-a06c-f3d1d748de84") ? null :
              <img
                src={
                  shiftData.pharmacy?.networkId === applicant?.networks[0].id ?
                    require('../../img/50x50-01.png')
                    : require('../../img/100x100-02-01.png')
                }
                alt={"networkIcon"}
                style={{
                  // width: 70,
                  height: 50,
                  marginLeft: 37
                }}
              />
            }
            {/* RB Pay Verified badge + Setup CTA — sit directly under the profile
                picture/logos (inside the avatar block) so they hug the photo rather
                than floating in the column's vertical center. */}
            {isWorkerRBPayVerified(applicant) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: Spacing.small,
                  marginTop: Spacing.small,
                }}
              >
                <RBPayrollVerifiedBadge />
                {locationRBPayNotSetup && account?.owner && (
                  <RBButton
                    // Non-breaking space before "RB" so the button's flex layout
                    // doesn't trim the gap when renderRBPayText splits on "RB Pay"
                    // (otherwise it renders as "SetupRB Pay").
                    text={"Setup RB Pay"}
                    onClick={goToRBPaySetup}
                    buttonBackgroundColor={primaryColor}
                    style={{ width: "100%" }}
                  />
                )}
              </div>
            )}
            </div>
          <RBButton
            buttonBackgroundColor={primaryColor}
            onClick={() => setExtendedsForPharmacist(applicant.id)}
            text={`View ${showExtended ? "less" : "more"}`}
          />
        </div>
        {/* Applicant Detail */}
        <div style={{ flex: 1, marginLeft: Spacing.larger,filter: shiftData?.pharmacy?.approval?.approvalMode  === ApprovalModeEnum.OnHold ? 'blur(4px)': 'none' }}>
          {renderName(applicant)}
          <div style={{ marginBottom: Spacing.medium }} />
          <div style={{ marginTop: Spacing.medium }}>
            {(pharmacist.type === workerTypeEnum.pharmacistStudent ||
              pharmacist.type === workerTypeEnum.technicianStudent) &&
              renderStudent(applicant)}
            {pharmacist.type === workerTypeEnum.assistant &&
              renderAssistant(applicant)}
            {(pharmacist.type === workerTypeEnum.pharmacist ||
              pharmacist.type === workerTypeEnum.technician) &&
              renderPharmacistAndTechnician(applicant)}
            {(pharmacist.type === workerTypeEnum.dentist ||
                pharmacist.type === workerTypeEnum.dentistRDA ||
                pharmacist.type === workerTypeEnum.dentistCDA ||
              pharmacist.type === workerTypeEnum.dentistLDA ||
                pharmacist.type === workerTypeEnum.dentistCDA2 ||
                pharmacist.type === workerTypeEnum.dentistRDT ||
                pharmacist.type === workerTypeEnum.dentistRDH ||
              pharmacist.type === workerTypeEnum.dentistLDH ||
                pharmacist.type === workerTypeEnum.denturist) &&
                renderLicensedDentistWorker(applicant)}
              {(pharmacist.type === workerTypeEnum.dentistAdministrator ||
                pharmacist.type === workerTypeEnum.dentistSterilizationAssistant ||
                pharmacist.type === workerTypeEnum.dentistDT ||
                pharmacist.type === workerTypeEnum.dentistChairSideAssistant ||
                pharmacist.type === workerTypeEnum.dentistDA1 ||
                pharmacist.type === workerTypeEnum.dentistDA2 ||
                pharmacist.type === workerTypeEnum.dentistDA12 ||
                pharmacist.type === workerTypeEnum.LabourElectrical ||
                pharmacist.type === workerTypeEnum.LabourMechanical ||
                pharmacist.type === workerTypeEnum.LabourPlumber) &&
                renderNonLicensedDentistWorker(applicant)}
          </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              marginTop: Spacing.medium,
            }}
          >
            <RBButton
              isLoading={isButtonLoading}
              text="Select"
              onClick={() => onSelection(applicant)}
              style={{
                flex: 1,
                marginRight: 4,
                padding: 8,
                // marginVertical: 8,
              }}
              buttonBackgroundColor={secondaryColor}
            />
            <RBButton
              isLoading={isButtonLoading}
              text="Ignore"
              onClick={() => onReject(applicant)}
              style={{
                flex: 1,
                marginLeft: 4,
                padding: 8,
                // marginVertical: 8,
              }}
              buttonBackgroundColor={primaryColor}
            />
            
          </div>
        </div>
      </div>
      </>
    );
  };
  const onResumeClose= () => {
    setReumeModal(false)
    setSelectedApplicant(null);
   };
   const renderRequestedRateContent =  (applicant:any) => {
    console.log("selectedApplicant",applicant)
    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
          userSelect:"none",
          pointerEvents:"none"

        }}
      >
        
          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
              <Document  file={applicant.pdfDataUrl}
               onLoadSuccess={({ numPages })=>setNumPages(numPages)}
              onLoadError={(error) => console.error('PDF Load Error:', error)}>
                 {Array.apply(null, Array(numPages))
                .map((x, i)=>i+1)
                .map(page => <Page pageNumber={page}/>)}
              </Document>
          </RBCardView>
       
      </div>
    );
  };

 // sticky original shift details card shown at top of applicants list
  const renderOriginalShiftDetailsCard = () => {
    if (!shiftData || !shiftData.officialStartTime) return null;

    const tz = shiftData.shiftTimeZone || "UTC";
    const start = moment(shiftData.officialStartTime).tz(tz);
    const end = moment(shiftData.officialEndTime).tz(tz);
  const startDisplay = start.format("ddd, MMM Do YYYY h:mm a");
  const endDisplay = end.format("ddd, MMM Do YYYY h:mm a");
  const dateDisplay = start.format("ddd, MMM Do YYYY");
  const timeDisplay = `${start.format("hh:mm a")} - ${end.format("hh:mm a")}`;

    // use existing wage helper (keeps behaviour consistent with other components)
    const wageRaw = ShiftService.getWage(shiftData, account);
    const wageDisplay =
      wageRaw != null ? `$${(wageRaw / 100).toFixed(2)}` : "N/A";
    const allowOffers = shiftData?.allowOffers;

    return (
      <div
        style={{
          position: "sticky",
          // top: Spacing.large,
           top: TopAppBarHeight, 
          // zIndex: 60,
            zIndex: 1200, 
          marginBottom: Spacing.medium,
          display: "flex",
          justifyContent: "center",
          
        }}
      >
        <RBCardView
         marginHorizontal={Spacing.large}
          style={{
            width: "100%",
            maxWidth: 1100,
            paddingLeft: Spacing.large,
            paddingRight: Spacing.large,
            paddingTop: Spacing.medium,
            paddingBottom: Spacing.medium,
             // center the card content
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
             boxShadow: "0 2px 6px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.08)",
          overflow: "visible",
          // overflowX: "auto", // allow horizontal scroll on very small screens
          }}
        >
          <div 
          style={{ marginBottom: Spacing.xlarge }}
          >
            <div
             style={{ fontSize: FontSize.larger, fontWeight: "bold" }}
            >
              Original Shift Details
            </div>
          </div>

          {/* <div 
          style={{ 
            display: "flex", 
            flexDirection: "row",
             gap: 32,
              justifyContent: "space-between",
              alignItems: "center",
              // allow wrapping on narrow screens
              flexWrap: "wrap",
             }}
             >
            <div style={ColumnStyle}>

              {renderTextWithTitleAndChildComponent(
                                "Date",
                                <div style={{color: 'rgb(52, 175, 71)'}}>{dateDisplay}</div>)}


               {/* <div style={{ fontWeight: "bold" }}>Date</div>
              // <div>{dateDisplay}</div> */}
            {/* </div> */}

            {/* <div style={ColumnStyle} > */}


{/* {renderTextWithTitleAndChildComponent( */}
                                {/* "Hourly Rate", */}
                                {/* <div style={{...ColumnStyle,color: 'rgb(52, 175, 71)'}}>{wageDisplay}</div>)} */}



              {/* <div style={{ fontWeight: "bold" }}>Hourly Rate</div>
              <div>{wageDisplay}</div> */}
            {/* </div> */}

            {/* <div  style={ColumnStyle}> */}

            {/* {renderTextWithTitleAndChildComponent( */}
                                {/* "Time", */}
                                {/* <div style={{color: 'rgb(52, 175, 71)'}}>{timeDisplay}</div>)} */}


              {/* <div style={{ fontWeight: "bold" }}>Time</div>
              <div>{timeDisplay}</div> */}
            {/* </div> */}
          {/* </div> */} 
           <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: Spacing.small }}>
             {/* First row: Start Time (left) | Duration (right) */}
             <div style={{ display: "flex", width: "100%", gap: 32, alignItems: "center", flexWrap: "wrap" }}>
               <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", minWidth: 180 }}>
                 <div style={{ color: Colors.darkGrey, fontSize: FontSize.default, marginBottom: 6, textAlign: "left" }}>Start Time</div>
                 <div style={{ ...detailTextStyle, color: "rgb(52, 175, 71)", textAlign: "left", whiteSpace: "nowrap" }}>{startDisplay}</div>
               </div>

               <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", minWidth: 180, marginLeft: "auto" }}>
                 <div style={{ color: Colors.darkGrey, fontSize: FontSize.default, marginBottom: 6, textAlign: "left" }}>Duration</div>
                 <div style={{ ...detailTextStyle, color: "rgb(52, 175, 71)", textAlign: "left", whiteSpace: "nowrap" }}>{ShiftService.getDurationDisplay(shiftData.officialStartTime, shiftData.officialEndTime, tz)}</div>
               </div>
             </div>

             {/* Second row: End Time (left) | Hourly Rate (right) */}
             <div style={{ display: "flex", width: "100%", gap: 32, alignItems: "center", flexWrap: "wrap" }}>
               <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", minWidth: 180 }}>
                 <div style={{ color: Colors.darkGrey, fontSize: FontSize.default, marginBottom: 6, textAlign: "left" }}>End Time</div>
                 <div style={{ ...detailTextStyle, color: "rgb(52, 175, 71)", textAlign: "left", whiteSpace: "nowrap" }}>{endDisplay}</div>
               </div>

               <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", minWidth: 180, marginLeft: "auto" }}>
                 <div style={{ color: Colors.darkGrey, fontSize: FontSize.default, marginBottom: 6, textAlign: "left" }}>Hourly Rate</div>
                 <div style={{ ...detailTextStyle, color: "rgb(52, 175, 71)", textAlign: "left", whiteSpace: "nowrap" }}>{wageDisplay}</div>
               </div>
             </div>
           </div>
          

        </RBCardView>
      </div>
    );
  };

  return (
    <>
     
      {renderAlerts()}
      <RBErrorAlert
        show={!!submitErrorMessage}
        errorMessage={submitErrorMessage || ''}
        onClose={() => {
          setSubmitErrorMessage(undefined);
        }}
      />



       <RBProofModal
        open={proofsModalOpen}
        onClose={closeProofsModal}
        modalTitle={"Proof of Credentials"}
        header={<RBEmptyBlock style={{ width: "100%", height: Spacing.large, backgroundColor: Colors.defaultGrey }} />}
        children={
          <div style={{ display: "inline-block", width: 640, maxWidth: "90vw", verticalAlign: "top" }}>
          <RBCardView style={{ padding: Spacing.large }}>
            {proofList.map((p) => (
              <div key={p.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: Spacing.small }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{p.name}</div>
                  {/* <div style={{ color: Colors.darkGrey }}>{p.updatedAt ? moment(p.updatedAt).format('YYYY-MM-DD hh:mm A') : ""}</div> */}
                </div>
                <RBButton text="View" onClick={() => openProofViewer(p)} buttonBackgroundColor={secondaryColor} />
              </div>
            ))}
          </RBCardView>
          <div style={{ display: "flex", justifyContent: "center", padding: Spacing.medium }}>
        <RBButton
          text="Close"
          onClick={closeProofsModal}
          buttonBackgroundColor={primaryColor}
          style={{ minWidth: 160 }}
        />
      </div>
    </div>

        }
      />


      <RBModal
        open={proofViewerOpen}
        onClose={closeProofViewer}
        modalTitle={selectedProof?.name || "Document"}
        header={<RBEmptyBlock style={{ width: "100%", height: Spacing.large, backgroundColor: Colors.defaultGrey }} />}
        children={
          <RBCardView style={{ padding: Spacing.large }}>
            {selectedProof?.fileUrl && selectedProof?.isPdf ? (
              <>
                <Document
                  file={selectedProof.fileUrl}
                  onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  onLoadError={(error) => {
                    console.error("PDF Load Error:", error);
                    setSubmitErrorMessage({ message: "Unable to load PDF" } as any);
                  }}
                >
                  {Array.from(new Array(numPages), (_el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                  ))}
                </Document>
              </>
            ) : selectedProof?.fileUrl ? (
              <div style={{ textAlign: "center" }}>
                <img src={selectedProof.fileUrl} alt={selectedProof.name} style={{ maxWidth: "100%", maxHeight: "80vh" }} />
              </div>
            ) : null}
          </RBCardView>
        }
        />




      {isPageLoading ? (
        <LoadingIndicator />
      ) : (
          <>
            <div style={{ marginTop: Spacing.large, marginBottom: Spacing.large }}>
              {applicants.length === 0 && (
                <RBCardView
                  marginHorizontal={Spacing.medium}
                  style={{
                    padding: Spacing.large,
                    marginTop: Spacing.medium,
                  }}
                >
                  No applicants yet, try back later!
                </RBCardView>
              )}
            </div>
            {/* <div style={{ marginTop: Spacing.large, marginBottom: Spacing.large }}> */}
            <div style={{
               marginTop: Spacing.larger,
               marginLeft:Spacing.larger,
               marginRight:Spacing.larger, 
               marginBottom: Spacing.larger 
               }}>
             {!isSingleView && renderOriginalShiftDetailsCard()}
             {/* </div> */}
              {applicants.map((applicant) => (
                <div
                  key={applicant.id}
                  children={
                    <RBCardView
                      marginHorizontal={Spacing.large}
                      style={{ marginBottom: Spacing.large }}
                      children={renderApplicant(applicant)}
                    />
                  }
                />
              ))}
            </div>
          </>
      )}
    </>
  );
};

export const ViewApplicantsPage = withRouter(ViewApplicantsPageWithoutRouter);
